<template>
  <v-container class="custom-container custom-responsive-height">
    <v-row dense>
      <v-col cols="12">
        <v-card class="pa-5" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
          <v-row dense>
            <v-col cols="10">
              <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here ..." single-line solo
                hide-details class="custom-v-input"></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn large tile block elevation="0" to="/add-news" class="ma-0 text-capitalize btn-account"
                color="greenMain" height="48px">
                Add News
              </v-btn>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                  <v-data-table :headers="headers" :items="news" :search="search" :items-per-page="5">
                    <template v-slot:item.sl="{ item, index }">
                      {{ index + 1 }}
                    </template>
                    <template v-slot:item.created_at="{ item, index }">
                      {{ formatMySQLDate(item?.created_at) }}
                    </template>
                    <template v-slot:item.details="{ item }">
                      <router-link class="links text-decoration-none mr-3" :to="`/edit-news/${item.id}`">
                        <v-icon color="#039de9" small>
                          mdi-pencil-outline
                        </v-icon>
                      </router-link>
                      <v-dialog v-model="deleteNewsModal" max-width="400" class="rounded-0">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="#FF567F" small v-bind="attrs" v-on="on">
                            mdi-trash-can-outline
                          </v-icon>
                        </template>
                        <v-card rounded="0" width="400" class="auth-modal-card"
                          :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'">
                          <v-card-title class="px-0 pt-0"> Delete? </v-card-title>
                          <v-card-text class="px-0">Do you want to delete?</v-card-text>
                          <v-card-actions class="px-0 pb-0">
                            <v-btn class="elevation-0" :color="$vuetify.theme.dark ? '#FF567F' : '#FF567F'"
                              @click="deleteNews(item); deleteNewsModal = false">
                              Delete
                            </v-btn>
                            <v-btn class="elevation-0" :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'" outlined
                              @click.prevent="deleteNewsModal = false">
                              Cancel
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formatMySQLDate } from "@/_helpers/formateDate";
import { NEWS__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      deleteNewsModal: false,
      search: "",
      headers: [
        { text: "SL", value: "sl", align: "start" },
        { text: "Date", value: "created_at" },
        { text: "Title", value: "name" },
        { text: "Category", value: "catgory_name" },
        { text: "Action", value: "details" },
      ],
    };
  },

  computed: {
    ...mapState("news", ["news"]),
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    formatMySQLDate,
    ...mapActions("news", [NEWS__ACTIONS.GETNEWS, NEWS__ACTIONS.DELETENEWS]),
    
    deleteNews(item) {
      this[NEWS__ACTIONS.DELETENEWS]({ id: item?.id });
    },
  },

  async created() {
    this[NEWS__ACTIONS.GETNEWS]();
  },
};
</script>
